import { Room } from 'models/index';

import { endpoint, EndpointError } from '../endpoint';

export type GetOnAirRoomsParams = void;
export type GetOnAirRoomsResult = { rooms: Array<Room.RoomDataAdminResponse> };
export type GetOnAirRoomsError = EndpointError;

export const getOnAirRooms = endpoint<GetOnAirRoomsParams, GetOnAirRoomsResult, GetOnAirRoomsError>({
  method: 'GET',
  url: () => `/room/get-on-air-rooms`,
});
